import { InputAdornment } from '@mui/material';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import RHFRadioGroups from '../../../../components/hook-form/RHFRadioGroups';
import AcceptOrRejectWithQuestionsWithReason from '../AcceptOrRejectWithQuestionsWithReason';

const FormInputRadio = ({ name, data, disabled, index, refetch, ...props }) => {
  const { control, watch, setValue } = useFormContext();

  let watchParent;
  if (data?.options?.parentId) watchParent = watch(`${data?.options?.parentId}`);

  const options = useMemo(() => {
    return {
      array: data?.options?.items?.map((x) => ({ label: x.label, value: x.label })),
      data: data?.options,
    };
  }, [data]);

  const onChange = (e) => {
    // const value= e.target.value
    const afterChange = data?.options?.afterChange;
    if (afterChange) {
      const childs = Object.values(data?.options?.childs || {});
      if (afterChange.by === 'parent' && childs?.length) {
        const is = true;
        if (is) {
          if (afterChange.type === 'resetChilds') {
            // console.log("* * * FormInputRadio resetChilds" ,);
            childs?.map((x) => setValue(x?.name, null));
          }
        }
      }
    }
  };

  console.log({ options, data }, data?.label, '* * * FormInputRadio');

  return (
    <RHFRadioGroups
      options={options?.array || []}
      name={name}
      label={data?.label}
      disabled={disabled}
      required={data?.options?.required}
      onChange={onChange}
      InputProps={
        data?.need_confirm //&& isHistory
          ? {
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    display: 'flex',
                    gap: 1,
                  }}
                >
                  <AcceptOrRejectWithQuestionsWithReason
                    {...data?.client_inputs?.[index || 0]}
                    history={data?.old_client_inputs?.[index || 0]}
                    type={data?.type}
                    refetch={refetch}
                  />
                </InputAdornment>
              ),
            }
          : ''
      }
      {...props}
    />
  );
};

export default FormInputRadio;
